import PrecallSurvey from '@components/pages/account/survey/PrecallSurvey';
import { SurveyStep } from '@components/pages/account/survey/PrecallSurvey/constants';

export const PrecallSoa = () => <PrecallSurvey step={SurveyStep.SOA} />;

export default PrecallSoa;
